export const hesa = state => state.contactReducer.person.student.hesa.hesa

export const snapshots = state => state.contactReducer.person.student.hesa.snapshots

export const options = state => state.contactReducer.person.student.hesa.options

export const isSuccess = state => state.contactReducer.person.student.hesa.isSuccess

export const permissions = state => state.contactReducer.person.student.hesa.permissions
